// extracted by mini-css-extract-plugin
export default {"selection":"LeadItem_selection__sRMhR","active":"LeadItem_active__6dwW1","address":"LeadItem_address__3ASO7","actions":"LeadItem_actions__-RBgl","name":"LeadItem_name__Av7w4"};